// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__qK874","fileBtn":"File_fileBtn__hiIKp","closeBtn":"File_closeBtn__3xcpp","fileSelected":"File_fileSelected__3aeu0","disabled":"File_disabled__2fnNc"};